module.exports = __webpack_public_path__ + "img/chatroom_list.cf8c3d95.svg";